<template>
  <b-table :data="refillStocks" narrowed hoverable>
    <b-table-column field="id" label="ID" v-slot="props">{{
      props.row.id
    }}</b-table-column>
    <b-table-column
      field="createdAt"
      :label="$t('refillsStock.date')"
      sortable
      v-slot="props"
    >
      {{
        moment
          .utc(props.row.createdAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY HH:mm:ss")
      }}
    </b-table-column>
    <b-table-column
      field="userName"
      :label="$t('refillsStock.user')"
      v-slot="props"
      >{{ props.row.userName }}</b-table-column
    >
    <b-table-column
      field="operation"
      :label="$t('refillsStock.operation')"
      v-slot="props"
      >{{ props.row.operation }}</b-table-column
    >
    <b-table-column
      field="status"
      :label="$t('refillsStock.status')"
      v-slot="props"
      >{{ translateStatus(props.row.status) }}</b-table-column
    >
    <b-table-column
      field="quantity"
      :label="$t('refillsStock.quantity')"
      numeric
      v-slot="props"
      >{{ props.row.quantity }}</b-table-column
    >
    <b-table-column
      field="quantityBefore"
      :label="$t('refillsStock.quantityBefore')"
      numeric
      v-slot="props"
      >{{ props.row.quantityBefore }}</b-table-column
    >
    <b-table-column
      field="quantityAfter"
      :label="$t('refillsStock.quantityAfter')"
      numeric
      v-slot="props"
      >{{ props.row.quantityAfter }}</b-table-column
    >
    <template slot="empty"
      ><table-empty-template
    /></template>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["refillStocks"],
  mixins: [common],
  components: { tableEmptyTemplate },
  methods: {
    translateStatus(status) {
      const translations = {
        success: "statusSuccess",
        refused: "statusRefused",
        preemptivelyRefused: "statusRefused",
        error: "statusError",
        cancelled: "statusCancelled",
        open: "statusOpen",
        pending: "statusPending",
        refundedRequested: "statusRefundRequested",
        refundRequested: "statusRefundRequested",
        refunded: "statusRefunded",
        refundRefused: "statusRefundRefused",
        refundFailed: "statusRefundFailed",
        refundReversed: "statusRefundReversed",
        chargeback: "statusChargeback",
        chargebackPaid: "statusChargebackPaid",
        billingPending: "statusBillingPending"
      };
      return translations[status]
        ? this.$t(`transactions.${translations[status]}`)
        : status || "-";
    }
  },
  computed: mapGetters(["preferences"])
};
</script>
